// extracted by mini-css-extract-plugin
export default {"rightSide":"Header_rightSide__2SUt-","leftSide":"Header_leftSide__Q5f1f","navIcon":"Header_navIcon__Wzu6y","Search":"Header_Search__KHos3","navIcons":"Header_navIcons__2WCcD"};